module.exports = __webpack_public_path__ + "static/media/Bath5.fd02a904.jpg";